import React, { useState, useRef } from "react";
import jsPDF from "jspdf";

function App() {
  const [formData, setFormData] = useState({
    klantnaam: "",
    adres: "",
    postcode: "",
    plaats: "",
    btwTarief: "21%",
    opmerkingen: "",
    foto: null
  });

  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "foto") {
      setFormData({ ...formData, foto: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Gegevens opgeslagen. Klik op 'Genereer PDF' om rapport te exporteren.");
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.text("Inspectie & Offerteformulier", 10, 10);
    doc.text(`Klantnaam: ${formData.klantnaam}`, 10, 20);
    doc.text(`Adres: ${formData.adres}`, 10, 30);
    doc.text(`Postcode: ${formData.postcode}`, 10, 40);
    doc.text(`Plaats: ${formData.plaats}`, 10, 50);
    doc.text(`BTW-tarief: ${formData.btwTarief}`, 10, 60);
    doc.text("Opmerkingen:", 10, 70);
    doc.text(formData.opmerkingen || "-", 10, 80);

    if (formData.foto) {
      const reader = new FileReader();
      reader.onload = function (event) {
        const img = event.target.result;
        doc.addImage(img, "JPEG", 10, 90, 100, 75);
        doc.save("inspectie_offerte.pdf");
      };
      reader.readAsDataURL(formData.foto);
    } else {
      doc.save("inspectie_offerte.pdf");
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "auto", padding: 20 }}>
      <h1>Inspectie & Offerteformulier</h1>
      <form onSubmit={handleSubmit}>
        <input name="klantnaam" placeholder="Klantnaam" value={formData.klantnaam} onChange={handleChange} /><br />
        <input name="adres" placeholder="Adres" value={formData.adres} onChange={handleChange} /><br />
        <input name="postcode" placeholder="Postcode" value={formData.postcode} onChange={handleChange} />
        <input name="plaats" placeholder="Plaats" value={formData.plaats} onChange={handleChange} /><br />
        <input name="btwTarief" placeholder="BTW-tarief" value={formData.btwTarief} onChange={handleChange} /><br />
        <textarea name="opmerkingen" placeholder="Opmerkingen" value={formData.opmerkingen} onChange={handleChange}></textarea><br />
        <input type="file" name="foto" ref={fileInputRef} onChange={handleChange} accept="image/*" /><br /><br />
        <button type="submit">Opslaan</button>
        <button type="button" onClick={generatePDF} style={{ marginLeft: 10 }}>Genereer PDF</button>
      </form>
    </div>
  );
}

export default App;